import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { Divider, Modal, Button, Input, Select, Steps, Form } from "antd";
import {
  SolutionOutlined,
  UserOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import bcrypt from "bcryptjs";
import { error, success, warning } from "../../Controllers/toast";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import { baseUrl } from "../../Controllers/rest_api_config";
import { gql, useMutation } from "@apollo/client";
import CodeValidation from "./OTPComponent";
import OTPInput from "./OTPComponent";

const { Option } = Select;
const { Search } = Input;

const LOGIN_MOBILE = gql`
  mutation loginWithMobile($mobile: String!) {
    SendMobileCode(mobile: $mobile) {
      mobile
      code
    }
  }
`;

const MobileValidation = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);

  //   const [visible, setVisible] = useState(props.visible);
  //   const [destination, setDestination] = useState(props.destination);

  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [numberVisible, setNumberVisible] = useState(
    props.numberVisible || true
  );
  const [seconds, setSeconds] = useState(120);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [codeGenerate, setCodeGenerate] = useState(0);
  const [current, setCurrent] = useState(0);
  const [code, setCode] = useState(0);

  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  const [sendCode] = useMutation(LOGIN_MOBILE, {
    onCompleted: (res) => {
      // console.log(res)
      setCodeGenerate(res.SendMobileCode.code);
      setNumberVisible(false);
    },
    onError: (err) => {
      error("مشکلی در دریافت اطلاعات رخ داده است!");
      // console.log(err)
    },
  });

  //   console.log("check props" , visible , destination , props);
  useEffect(() => {
    if (props.handleCancelModal === true) {
      // console.log("in the change condition modal visible");
      handleCancel();
      props.setHandleCancelModal(false);
    }
    let interval = null;
    if (props.visible === true && numberVisible === false && current === 1) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
      document.getElementById("time-style").style.display = "block";
      if (seconds <= 10) {
        document.getElementById("time-style").style.color = "red";
      } else {
        document.getElementById("time-style").style.color = "black";
      }
      if (seconds === 0) {
        setNumberVisible(true);
        clearInterval(interval);
        setBtnDisabled(true);
      }
    } else if ((props.visible === false) & (seconds !== 0)) {
      // setSeconds(60)
    }

    return () => clearInterval(interval);
  }, [seconds, props.visible, numberVisible, setNumberVisible]);

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      //   setLoading(false);
      props.setVisible(false);
      window.location.replace("#/register");
    }, 1000);
  };

  const handleCancel = () => {
    props.setVisible(false);
    setSeconds(120);
    setCurrent(0);
    setNumberVisible(true);
    document.getElementById("time-style").style.display = "none";
  };

  const handleChangePhone = (v) => {
    // v.preventDefault();
    // console.log(v.target.value);
    setPhone(v);
    // console.log(phone, "is phone number");
  };
  const sendMobileNumber = () => {
    props.setMobile(phone);
  };

  const sendRequestToKaveNegar = async () => {
    sendMobileNumber();
    sendCode({ variables: { mobile: JSON.stringify(phone) } });
  };
  const steps = [
    {
      content: (
        <Row style={{ marginBottom: 16 }}>
          <Col
            className="text-center"
            sm={12}
            xs={12}
            md={12}
            lg={12}
            xl={12}
            style={{ marginBottom: "25px" }}
          >
            <PhoneInput
              onKeyDown={async (e) => {
                // console.log(e.key);
                if (e.key === "Enter" || e.key === "Go") {
                  if (phone === "" || phone.length < 5) {
                    warning("شماره تلفن همراه خود را بدرستی وارد کنید!");
                    // console.log("phone is empty");
                  } else {
                    await sendRequestToKaveNegar();
                    setCurrent(current + 1);
                  }
                }
              }}
              style={{
                direction: "ltr",
                textAlign: "left",
                width: "100% !important",
              }}
              country="ir"
              regions={[
                "north-america",
                "south-america",
                "central-america",
                "carribean",
                "eu-union",
                "ex-ussr",
                "ex-yugos",
                "baltic",
                "middle-east",
                "north-africa",
              ]}
              masks={{ ir: ".........." }}
              // defaultMask={'--- ------'}
              enableSearch
              onChange={handleChangePhone}
            />
          </Col>

          <Col className="text-center" sm={12} xs={12} md={12} lg={12} xl={12}>
            <Button
              onClick={async () => {
                if (phone === "" || phone.length < 5) {
                  warning("شماره تلفن همراه خود را بدرستی وارد کنید!");
                  // console.log("phone is empty");
                } else {
                  await sendRequestToKaveNegar();
                  setCurrent(current + 1);
                }
              }}
              type="primary"
            >
              {lang_choiced.pages.login.moibleRegister.modal.sections[0].btnRecieve}
            </Button>
          </Col>

          {
            // <Input
            //   addonBefore={selectBefore}
            //   defaultValue="mysite"
            //   style={{ direction: "ltr", marginBottom: "15px" }}
            // />
          }
        </Row>
      ),
    },
    {
      content: (
        <div>
          <div className="w-100 text-center mb-3">
            <h6>
            {lang_choiced.pages.login.moibleRegister.modal.sections[0].numberTitle}: <b>{phone}</b>
            </h6>
          </div>
          {/* <Search
            type="text"
            maxLength={6}
            placeholder="کد تایید ارسال شده را وارد کنید"
            enterButton="بررسی"
            size="large"
            onSearch={(value) => {
              if (value.length < 4) {
                // console.log(value, "is not exist");
                // console.log(navigator.geolocation);
                warning("لطفا حداقل 4 رقم وارد کنید!");
              } else {
                // console.log(value , codeGenerate);
                
                // Axios.post(
                //   `${baseUrl}/auth/checkCode`,
                //   {},
                //   { params: { code: value } }
                // )
                //   .then((res) => {
                //     // Set Mobile Code Token in LocalStorage
                //     setBtnDisabled(false);
                //     toast.success("کد شما تایید شد !");
                //   })
                //   .catch((err) => console.log(err, "is error"));
              }
            }}
            style={{ direction: "ltr" }}
            disabled={numberVisible}
            // loading={loading}
          /> */}
          <OTPInput
            length={6}
            code={codeGenerate}
            setCode={(e) => setCode(e)}
            onComplete={(e) => {
              // console.log("Okay!!!");
              // if (bcrypt.compareSync(code, codeGenerate)) {
              //   // !props.register?success("احراز هویت باموفقیت انجام شد!"):console.log("");
              props.setResponse(true);
              //   // setBtnDisabled(false);
              // } else {
              //   error("کد وارد شده نامعتبر است!");
              // }
            }}
            btnDisabled={btnDisabled}
          />
          <div className="mt-1">
            <div className="time" id="time-style" style={{ display: "none" }}>
              {seconds} {lang_choiced.pages.login.moibleRegister.modal.sections[0].timerText}
              <br />
              {seconds === 0 ? (
                <Button
                  onClick={async () => {
                    await sendRequestToKaveNegar();
                    setSeconds(120);
                    setBtnDisabled(false);
                  }}
                >
                  {lang_choiced.pages.login.moibleRegister.modal.sections[0].btnRecieve} <SyncOutlined />
                </Button>
              ) : (
                ""
              )}
            </div>
            <div className="text-center">
              <Button
                type="primary"
                onClick={() => {
                  if (bcrypt.compareSync(code, codeGenerate)) {
                    // !props.register?success("احراز هویت باموفقیت انجام شد!"):console.log("");
                    props.setResponse(true);
                    // setBtnDisabled(false);
                  } else {
                    error("کد وارد شده نامعتبر است!");
                  }
                }}
              >
                {lang_choiced.pages.login.moibleRegister.modal.sections[0].btnSend}
              </Button>
            </div>
          </div>
        </div>
      ),
    },
  ];
  return (
    <Modal
      open={props.visible}
      title={lang_choiced.pages.login.moibleRegister.modal.title}
      // onOk={handleOk}
      onCancel={handleCancel}
      footer={
        <div className="footer-modal">
          {current === 1 && (
            <Button
              className="cancel_btn"
              type="text"
              key="back"
              onClick={() => {
                setCurrent(0);
                setSeconds(120);
              }}
            >
              {lang_choiced.pages.login.moibleRegister.modal.sections[0].btnBack} &larr;
            </Button>
          )}
          {
            // <Button
            //   className="submit_btn"
            //   type="primary"
            //   key="submit"
            //   // loading={loading}
            //   onClick={handleOk}
            //   disabled={btnDisabled}
            // >
            //   {lang_choiced.components.login.mobile_auth.submit_btn}
            // </Button>
          }
        </div>
      }
    >
      <Steps
        current={current}
        items={[
          {
            key: 0,
            title: lang_choiced.pages.login.moibleRegister.modal.sections[0].title,
            // status: "finish",
            icon: <UserOutlined />,
          },
          {
            key: 1,
            title: lang_choiced.pages.login.moibleRegister.modal.sections[1].title,
            // status: "finish",
            icon: <SolutionOutlined />,
          },
        ]}
      />
      <div style={{ minHeight: "200px", alignContent: "center" }}>
        {steps[current].content}
      </div>
    </Modal>
  );
};

export default MobileValidation;
